import { useQuery } from '@hooks/reactQuery';

import { getMavenirConfigs } from '@api/dataSources';

import { extractQueryParams } from '@utils/common';

import { IMavenirConfig, IMavenirConfigInfo } from '@interfaces/cmModule/dataSources';
import { IMavenirConfigsDTO } from '@interfaces/cmModule/dto/dataSourceDTO';

import { refetchOptions } from '@constants/common';
import { MAVENIR_CONFIGS } from '@constants/queryKeys';

interface IMavenirConfigsReturnType {
	mavenirConfigs: {
		gnbId: string;
		subRows: IMavenirConfigInfo[];
	}[];
	countOfRecords: number;
	isLoadingMavenirConfigs: boolean;
}

const useQueryMavenirConfigs = (params: IMavenirConfigsDTO): IMavenirConfigsReturnType => {
	const {
		data: mavenirConfigs,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [MAVENIR_CONFIGS, params],
		queryFn: extractQueryParams(getMavenirConfigs),
		select: (data) => {
			return {
				items: data?.items.map((item: IMavenirConfig) => ({
					gnbId: item.gnbId,
					subRows: item.entities,
				})) || [],
				count: data?.count || 0,
			};
		},
		...refetchOptions,
	});

	return {
		mavenirConfigs: mavenirConfigs?.items || [],
		countOfRecords: mavenirConfigs?.count || 0,
		isLoadingMavenirConfigs: isLoading || isFetching,
	};
};

export default useQueryMavenirConfigs;
